// Copyright (c) 2022 WiseTime. All rights reserved.

import { activateI18n } from "../../locales/i18nUtil"
import { ManualTimeRow } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { t } from "@lingui/macro"

activateI18n()

/* eslint-disable lingui/no-unlocalized-strings */
const activities = [
  "Researching",
  "Meeting",
  "Phonecall",
  "Videocall",
  "Drafting",
  "Corresponding",
  "Travel",
  "Other"
]
/* eslint-enable lingui/no-unlocalized-strings */

export type Activity = typeof activities[0]
export type ActivityTypeOption = {
  name: Activity,
  value: ManualTimeRow.ManualTimeCategory,
  displayText: string,
}

export const defaultActivityOption = (): ActivityTypeOption => {
  return {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    name: "Researching",
    value: ManualTimeRow.ManualTimeCategory.RESEARCHING,
    displayText: t({ id: "option_activity_type_researching", message: "Researching" })
  }
}

// We need to generate the list lazily, otherwise the i18n might not work
/* eslint-disable lingui/no-unlocalized-strings */
export const generateActivityOptions = (): ActivityTypeOption[] => [
  defaultActivityOption(),
  {
    name: "Meeting",
    value: ManualTimeRow.ManualTimeCategory.MEETING,
    displayText: t({ id: "option_activity_type_meeting", message: "Meeting" })
  },
  {
    name: "Phonecall",
    value: ManualTimeRow.ManualTimeCategory.PHONE_CALL,
    displayText: t({ id: "option_activity_type_phonecall", message: "Phonecall" })
  },
  {
    name: "Videocall",
    value: ManualTimeRow.ManualTimeCategory.VIDEO_CALL,
    displayText: t({ id: "option_activity_type_videocall", message: "Videocall" })
  },
  {
    name: "Drafting",
    value: ManualTimeRow.ManualTimeCategory.DRAFTING,
    displayText: t({ id: "option_activity_type_drafting", message: "Drafting" })
  },
  {
    name: "Corresponding",
    value: ManualTimeRow.ManualTimeCategory.CORRESPONDING,
    displayText: t({ id: "option_activity_type_corresponding", message: "Corresponding" })
  },
  {
    name: "Travel",
    value: ManualTimeRow.ManualTimeCategory.TRAVEL,
    displayText: t({ id: "option_activity_type_travel", message: "Travel" })
  },
  {
    name: "Other",
    value: ManualTimeRow.ManualTimeCategory.OTHER,
    displayText: t({ id: "option_activity_type_other", message: "Other" })
  }
]
/* eslint-enable lingui/no-unlocalized-strings */
